import { shipmentStatusOptions } from '@/constants';
import type { CellRendererParams } from '@/grid/types';

import { statusColorMap } from './constants';

export const ShipmentStatusTag = (
  params:
    | CellRendererParams<Record<string, unknown>, number | null | undefined>
    | { value: number | null | undefined },
) => {
  const value = params.value;

  if (value === null || value === undefined) {
    return null;
  }

  const statusOption = shipmentStatusOptions.find(
    (option) => option.value === value,
  );

  if (!statusOption) {
    return null;
  }

  const statusColor = statusColorMap[value as keyof typeof statusColorMap];

  if (!statusColor) {
    return null;
  }

  return (
    <span
      className={`inline-flex items-center rounded-md px-3 py-1.5 text-sm font-medium ${statusColor.bgColor} ${statusColor.textColor}`}
    >
      {statusOption.label}
    </span>
  );
};
